import { whenever } from '@vueuse/core';
import { useCmdK } from './useCmdK';

export function useSearch() {
  const route = useRoute();

  /**
   * Checks if the search is currently open based on URL query params
   * @returns {boolean} Whether the search is open
   */
  const isSearchOpen = computed(() => {
    return route.query?.q !== undefined;
  });

  /**
   * Toggles the search modal by updating the URL query parameters
   * @returns {Promise} Navigation promise
   */
  function toggleSearch() {
    return navigateTo({
      path: route.currentPath || route.path,
      query: { ...route.query, q: '' },
    });
  }

  /**
   * Sets focus on the search icon after search is closed
   */
  function setFocusInSearchIcon() {
    if (typeof document === 'undefined') {
      return;
    }
    // We have no way to detect what the search icon is, so we assume it's the first element with the class 'focus-search-icon'
    // Should be set on a header component.
    const searchButton = document.querySelector('.focus-search-icon');
    if (searchButton) {
      searchButton.focus();
    }
  }

  useCmdK(toggleSearch);
  whenever(() => !isSearchOpen.value, setFocusInSearchIcon);

  return {
    isSearchOpen,
    toggleSearch,
    setFocusInSearchIcon,
  };
}
